import type { PostalAddressLike } from '@app/icare/documents/AddressSection'
import { formatAddress } from '@pkg/shared/utils'
import { Link } from '@tanstack/react-router'
import { Space, Typography } from 'antd'

export interface FormattedNameAndAddressProps {
  link?: {
    to: string
    params: Record<string, string>
  }
  address: PostalAddressLike | undefined
  name: React.ReactNode
}

export const FormattedNameAndAddress = ({ link, address, name }: FormattedNameAndAddressProps) => (
  <Space vertical size="small">
    {link ? (
      <Link to={link.to} params={link.params} onClick={event => event.stopPropagation()}>
        <Space size="small">{name}</Space>
      </Link>
    ) : (
      <Space size="small">{name}</Space>
    )}
    {address && <Typography.Text type="secondary">{formatAddress(undefined, address)}</Typography.Text>}
  </Space>
)
